import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="text-center mb-8 md:mb-10">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
          OOPBuy Spreadsheet Kategorien
        </h2>
        <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
          Entdecke alle Produktkategorien mit den besten OOPBuy Spreadsheet Listen
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
        {categories.map((cat) => (
          <a
            key={cat.name}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group flex flex-col overflow-hidden rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
          >
            <div className="w-full aspect-square overflow-hidden bg-background-100">
              <img
                src={cat.imageUrl}
                alt={`${cat.nameDe} - OOPBuy Spreadsheet Kategorie`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="p-3 md:p-4 flex items-center gap-2">
              <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                <i className={`${cat.icon} text-xs`}></i>
              </div>
              <span className="text-foreground-700 text-xs md:text-sm font-medium whitespace-nowrap">
                {cat.nameDe}
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}